import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  count?: ReactNode;
  children?: ReactNode;
}

export const MobileListHeader = ({ count, children }: Props) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={3}
    mb={3}
    data-testid="mobile-list-header"
  >
    <Typography variant="body3" color="textSecondary" noWrap>
      {count}
    </Typography>
    <Box display="flex" alignItems="center" gap={2} flex="none">
      {children}
    </Box>
  </Box>
);
